import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FeatureService } from 'src/app/private/services/feature.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-feature',
  imports: [SharedModule],
  templateUrl: './delete-feature.component.html',
  styleUrl: './delete-feature.component.scss'
})
export class DeleteFeatureComponent {

  @Input() featureDataToEdit: any = {};
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private featureService: FeatureService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteFeature() {
    this.isLoading = true;
    const payload = {
      feature_id: this.featureDataToEdit.feature_id,
    };
    this.featureService.deleteFeature(payload).subscribe(
      {
        next: (res: any) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Feature deleted successfully'
          });
          this.reload.emit();
          this.close.emit();
        },
        error: (err) => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'An error occurred while deleting the feature'
          });
        }
      }
    );
  }
}
